import styles from "./styles";
import global from "../../styles";
import classNames from "classnames";
import Decoration from "../decoration";
import { formatHeaderWords } from "../../helpers/formatHeaderWords";
import PropTypes from "prop-types";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

const Benefits = ({ assetsUrl }) => {
  const translate = useTranslate(useLocaleProvider());
  const header = translate("loyalty_landing_page_benefits_header");
  const headerFormatted = formatHeaderWords(header);
  return (
    <div className={styles.benefitsImageContainer} id="faqAnchor">
      <picture className={styles.benefitsImage}>
        <source
          srcSet={`${assetsUrl}/dWeb-Benefits_SS25_evi9yo`}
          media="(min-width: 480px)"
          width="100%"
        />
        <img
          src={`${assetsUrl}/mWeb-Benefits_SS25_yrhdxo`}
          alt="connect"
          width="100%"
          loading="lazy"
        />
      </picture>
      <div>
        <div
          className={classNames(styles.benefitsContainer, global.leftAlignment)}
        >
          <Decoration
            width="121"
            height="16"
            className={global.desktopAndTablet}
          />
          <Decoration
            width="60"
            height="144"
            className={global.desktopAndTablet}
          />
          <Decoration width="32" height="24" className={global.mobileOnly} />
          <Decoration width="187" height="16" className={global.mobileOnly} />
          <Decoration
            width="32"
            height="48"
            className={global.mobileOnly}
            x="0"
            y="0"
          />
          <div className={classNames(styles.header, global.headerASOSWorld)}>
            <h2 className={global.textBackground} aria-label={header}>
              {headerFormatted}
            </h2>
          </div>
          <Decoration
            width="32"
            height="24"
            className={global.desktopAndTablet}
          />
          <Decoration
            width="187"
            height="16"
            className={global.desktopAndTablet}
          />
          <Decoration width="343" height="72" className={global.mobileOnly} />
          <div
            className={classNames(
              global.leavesden1,
              styles.description,
              global.textBackground
            )}
          >
            {translate("loyalty_landing_page_benefits_body")}
          </div>
          <Decoration
            width="273"
            height="24"
            className={global.desktopAndTablet}
          />
          <Decoration
            width="221"
            height="24"
            className={global.mobileOnly}
            x="0"
            y="-2"
          />
        </div>
      </div>
    </div>
  );
};

export default Benefits;

Benefits.propTypes = {
  assetsUrl: PropTypes.string,
};
